import React, { Component } from 'react';
import './Home.css'
import Balloon from './Balloon'
import Tree from './Tree'
import Business from './Business'
import Chart from './Chart'
import Bridge from './Bridge'
import './Home.css'

class Home extends Component {

  constructor(props) {
    super(props)
    this.state = {
      bridge: {
        opacity: 0,
        marginTop: 100
      },
      balloon: {
        marginTop: 1000
      }
    }
    this.animateBridge = this.animateBridge.bind(this)
  }

  componentDidMount() {
    window.addEventListener('scroll', this.animateBridge);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.animateBridge);
  }

  animateBridge() {
    var scrollTop = window.pageYOffset
    var trigger = this.refs.trigger.offsetTop
    var winHeight = window.innerHeight
    if (scrollTop >= trigger - (winHeight / 4)) {
      this.setState ({
        bridge: {
          opacity: 1,
          marginTop: 0
        }
      });
    }
    if (scrollTop >= trigger + 200) {
      this.setState({
        balloon: {
          marginTop: 0
        }
      })
    }
  }

  render() {
    return (
      <div className="home-page">

        <Balloon />
        <Tree />
        <Business />
        <Chart />
        <div ref="trigger"></div>
        <Bridge balloon={this.state.balloon} bridge={this.state.bridge} />
      </div>
    );
  }
}

export default Home;



/** WEBPACK FOOTER **
 ** ./src/components/home/Home.js
 **/